import { render } from "./SearchResults.vue?vue&type=template&id=03866957"
import script from "./SearchResults.vue?vue&type=script&lang=js"
export * from "./SearchResults.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Tiresias\\Tiresias Project\\UI.Tiresias\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/SearchResults.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03866957"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03866957', __exports__)) {
    api.reload('03866957', __exports__)
  }
  
  module.hot.accept("./SearchResults.vue?vue&type=template&id=03866957", () => {
    api.rerender('03866957', render)
  })

}


export default __exports__